// components/PostItem.js

import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
// Using a lightweight custom menu instead of react-bootstrap Dropdown
// to avoid issues with popper/overflow in scrollable containers.
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FlagIcon from '@mui/icons-material/Flag';
import PushPinIcon from '@mui/icons-material/PushPin';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import { RiShareForwardFill } from "react-icons/ri";
import ReactPlayer from "react-player";
import Editbox from "../Timeline/Component/ViewPost/Component/Editbox/editbox";
import Commentmodal from "../commentmodal";
import Reportboxprofile from "../Report box profile";
import { formatRelativeTime } from "../../helpers/timeAgo";
import { Clock } from "react-bootstrap-icons";

const PostItem = ({
  post,
  name,
  images,
  mysetting,
  modalopen,
  setModalopen,
  setPostId,
  Deleteitem,
  setShows,
  setUpdatepost,
  postLikes,
  postDislikes,
  postStatus,
  handleClick,
  handleCommentClick,
  getTimelineComments,
  openCommentPostId,
  id,
  comment,
  comments,
  composerIdentity,
  resolveCommentIdentity,
  handleCommentChange,
  handleSubmit,
  getShareTimeline,
  handleShowshare,
  handleOpenShareModal,
  getAsset,
  setOpenCommentPostId,
  fullname,
  imgurl,
  isShared = false,
}) => {
  console.log("posti", post);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const rawTime =
    post?.timeAgo || formatRelativeTime(post?.createdAt || post?.created_at);
  const timeLabel = rawTime === "just now" ? rawTime : `${rawTime} ago`;
  const actionLabel = isShared ? "Shared" : "Posted";

  const resolveAvatarSrc = () => {
    const pick = (val) => {
      if (!val) return "";
      if (Array.isArray(val)) return val.find(Boolean) || "";
      return val;
    };
    if (isShared) {
      return (
        pick(imgurl) ||
        pick(post?.shopid?.image) ||
        pick(post?.shopid?.imageUrl) ||
        ""
      );
    }
    if (mysetting === "home") {
      return (
        pick(post?.shopid?.image) ||
        pick(post?.shopid?.imageUrl) ||
        pick(name?.imageUrl) ||
        ""
      );
    }
    return (
      pick(imgurl) ||
      pick(post?.shopid?.image) ||
      pick(post?.shopid?.imageUrl) ||
      pick(name?.imageUrl) ||
      ""
    );
  };

  const resolveDisplayName = () => {
    if (isShared) {
      return (
        fullname ||
        post?.shopid?.shopname ||
        name?.fullname ||
        ""
      );
    }
    if (mysetting === "home") {
      return post?.shopid?.shopname || name?.fullname || "";
    }
    return fullname || post?.shopid?.shopname || name?.fullname || "";
  };

  const avatarSrc = resolveAvatarSrc();
  const displayName = resolveDisplayName();
  const containerRef = useRef(null);
  const [isPinned, setIsPinned] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  // slider state/refs
  const sliderContainerRef = useRef(null);
  const sliderTrackRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Slider visuals
  const SLIDE_HEIGHT = 280; // px - uniform height for images/videos

  const getMediaArray = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val.flat(Infinity).filter(Boolean);
    if (typeof val === "string") return [val].filter(Boolean);
    return [];
  };

  // Prepare media list (images then videos)
  const imagesList = getMediaArray(post?.img);
  const videosList = getMediaArray(post?.video);
  const media = [...imagesList.map((s) => ({ type: 'image', src: s })), ...videosList.map((s) => ({ type: 'video', src: s }))];

  // Slider controls
  const prev = () => setCurrentSlide((s) => Math.max(0, s - 1));
  const next = () => setCurrentSlide((s) => Math.min(media.length - 1, s + 1));

  // no pointer or touch drag support for this slider; navigation is arrow-based only.

  // Keep slide position in sync with currentSlide (when not dragging)
  useEffect(() => {
    if (!sliderTrackRef.current || !sliderContainerRef.current) return;
    const width = sliderContainerRef.current.offsetWidth || 1;
    sliderTrackRef.current.style.transition = 'transform 300ms ease';
    sliderTrackRef.current.style.transform = `translateX(${-currentSlide * width}px)`;
  }, [currentSlide, media.length]);

  // Update on resize (use ResizeObserver when available)
  useEffect(() => {
    const el = sliderContainerRef.current;
    const updatePos = () => {
      if (!sliderTrackRef.current || !sliderContainerRef.current) return;
      const width = sliderContainerRef.current.offsetWidth || 1;
      sliderTrackRef.current.style.transition = 'none';
      sliderTrackRef.current.style.transform = `translateX(${-currentSlide * width}px)`;
    };

    if (typeof ResizeObserver !== 'undefined' && el) {
      const ro = new ResizeObserver(updatePos);
      ro.observe(el);
      return () => ro.disconnect();
    }

    window.addEventListener('resize', updatePos);
    return () => window.removeEventListener('resize', updatePos);
  }, [currentSlide, media.length]);

  // Clamp current slide when media length changes
  useEffect(() => {
    if (media.length === 0) {
      setCurrentSlide(0);
    } else if (currentSlide > media.length - 1) {
      setCurrentSlide(Math.max(0, media.length - 1));
    }
  }, [media.length]);

  useEffect(() => {
    const onPointerDown = (e) => {
      if (!dropdownOpen) return;
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setDropdownOpen(false);
    };

    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [dropdownOpen]);

  useEffect(() => {
    try {
      const pinned = JSON.parse(localStorage.getItem('pinnedPosts') || '[]');
      setIsPinned(Array.isArray(pinned) && pinned.includes(post?._id));
      const saved = JSON.parse(localStorage.getItem('savedPosts') || '[]');
      setIsSaved(Array.isArray(saved) && saved.includes(post?._id));
    } catch (e) {
      // ignore
    }
  }, [post?._id]);
  const copyLink = async (id) => {
    const link = `${window.location.origin}/post/${id}`;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(link);
      } else {
        const el = document.createElement('textarea');
        el.value = link;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      console.debug('Link copied', link);
    } catch (e) {
      console.error('Copy failed', e);
    }
  };

  return (
    <Row
      className="mt-3 bg-white rounded"
      key={post?._id}
      style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)", margin: "1px" }}
    >
      <Col lg="8" className="mt-2">
        <div className="d-flex">
          <img
            src={
              avatarSrc
                ? getAsset(avatarSrc)
                : images.noprofile
            }
            alt="Profile"
            className="personImgSize rounded-circle"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = images.noprofile;
            }}
          />
          <div>
            <h4 className="font-sm mb-0 fw-bold mt-2 ">
              &nbsp;&nbsp;
              {displayName}
            </h4>
            <div className="d-flex align-items-center ms-1">
              {/* <p className="font_small mb-0">&nbsp;&nbsp;{post.category}</p> */}
              <p className="font_small text-muted mb-0">
                <Clock size={12} className="me-1" />
                {actionLabel} {timeLabel}</p>
            </div>
          </div>
        </div>
      </Col>

      <Col
        lg="4"
        className="d-flex justify-content-end"
        style={{ position: "relative" }}
      >
        <div style={{ position: 'relative' }} ref={containerRef}>
          <button
            type="button"
            className="btn btn-link p-1"
            onClick={(e) => {
              console.debug('More toggle clicked', post?._id);
              e.stopPropagation();
              setDropdownOpen((s) => !s);
            }}
            onMouseDown={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            aria-expanded={dropdownOpen}
            style={{ cursor: 'pointer' }}
          >
            <MoreHorizIcon />
          </button>

          {dropdownOpen && (
            <div
              className="shadow-sm bg-white rounded p-2"
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                position: 'absolute',
                right: 0,
                top: '34px',
                zIndex: 3000,
                minWidth: 160,
                boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
                border: '1px solid rgba(0,0,0,0.06)'
              }}
            >
              {(mysetting && mysetting.length === 4) ? (
                <>
                  <button
                    type="button"
                    className="d-flex align-items-center"
                    onMouseEnter={() => setHoveredItem('edit')}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPostId(post._id);
                      setUpdatepost(true);
                      setDropdownOpen(false);
                    }}
                    style={{
                      backgroundColor: hoveredItem === 'edit' ? '#f6f8fa' : 'transparent',
                      color: '#212529',
                      border: 'none',
                      padding: '8px 12px',
                      width: '100%',
                      textAlign: 'left',
                      cursor: 'pointer',
                      transition: 'background-color 120ms ease'
                    }}
                  >
                    <EditIcon style={{ fontSize: 16, color: '#495057' }} className="me-2" />
                    <span style={{ fontSize: 13, lineHeight: '18px' }}>Edit Post</span>
                  </button>
                  <button
                    type="button"
                    className="d-flex align-items-center"
                    onMouseEnter={() => setHoveredItem('delete')}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPostId(post._id);
                      setShows(1);
                      setDropdownOpen(false);
                    }}
                    style={{
                      backgroundColor: hoveredItem === 'delete' ? '#fff5f5' : 'transparent',
                      color: '#c92a2a',
                      border: 'none',
                      padding: '8px 12px',
                      width: '100%',
                      textAlign: 'left',
                      cursor: 'pointer',
                      transition: 'background-color 120ms ease'
                    }}
                  >
                    <DeleteIcon style={{ fontSize: 16, color: hoveredItem === 'delete' ? '#c92a2a' : '#495057' }} className="me-2" />
                    <span style={{ fontSize: 13, lineHeight: '18px' }}>Delete Post</span>
                  </button>
                </>
              ) : (
                <button
                  className="d-flex align-items-center"
                  onMouseEnter={() => setHoveredItem('report')}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPostId(post._id);
                    setModalopen && setModalopen(post._id);
                    setDropdownOpen(false);
                  }}
                  style={{
                    backgroundColor: hoveredItem === 'report' ? '#fff9ec' : 'transparent',
                    color: '#856404',
                    border: 'none',
                    padding: '8px 12px',
                    width: '100%',
                    textAlign: 'left',
                    cursor: 'pointer',
                    transition: 'background-color 120ms ease'
                  }}
                >
                  <FlagIcon style={{ fontSize: 16, color: '#495057' }} className="me-2" />
                  <span style={{ fontSize: 13, lineHeight: '18px' }}>Report</span>
                </button>
              )}
              {/* Divider */}
              <div style={{ height: 8 }} />
              <div style={{ borderTop: '1px solid rgba(0,0,0,0.06)', margin: '0px 0' }} />
              <button
                type="button"
                className="d-flex align-items-center"
                onMouseEnter={() => setHoveredItem('copy')}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={(e) => {
                  e.stopPropagation();
                  copyLink(post?._id);
                  setDropdownOpen(false);
                }}
                style={{
                  backgroundColor: hoveredItem === 'copy' ? '#f6f8fa' : 'transparent',
                  color: '#212529',
                  border: 'none',
                  padding: '8px 12px',
                  width: '100%',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'background-color 120ms ease'
                }}
              >
                <ContentCopyIcon style={{ fontSize: 15, color: '#495057' }} className="me-2" />
                <span style={{ fontSize: 13, lineHeight: '18px' }}>Copy Link</span>
              </button>
            </div>
          )}
        </div>
      </Col>

      <h5 className="font-navy font-bold mt-3 mb-1">{post.heading}</h5>
      <p className="font_small">{post.content}</p>

      {
        // Use the top-level `media` array prepared above
        (() => {
          if (media.length === 0) return null;

          if (media.length === 1) {
            const item = media[0];
            return item.type === 'image' ? (
              <div style={{ height: `${SLIDE_HEIGHT}px`, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
                <img
                  src={getAsset(item.src)}
                  alt={post?.heading || ''}
                  loading="lazy"
                  style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', margin: '0 auto' }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = noImagePlaceholder;
                  }}
                />
              </div>
            ) : (
              <div style={{ height: `${SLIDE_HEIGHT}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000' }}>
                <ReactPlayer url={getAsset(item.src)} controls={true} width="100%" height="100%" playing={false} config={{ file: { attributes: { playsInline: true } } }} />
              </div>
            );
          }

          return (
            <div
              ref={sliderContainerRef}
              className="post-media-slider"
              style={{ position: 'relative', overflow: 'hidden', height: `${SLIDE_HEIGHT}px`, background: '#f6f7f9', borderRadius: 8 }}
            >
              <div
                ref={sliderTrackRef}
                className="slider-track"
                style={{ display: 'flex', height: '100%' }}
              >
                {media.map((item, i) => (
                  <div
                    key={i}
                    className="slider-item"
                    style={{
                      flex: '0 0 100%',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      background: '#fff'
                    }}
                  >
                    {item.type === 'image' ? (
                      <img
                        src={getAsset(item.src)}
                        alt={post?.heading || ''}
                        loading="lazy"
                        style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', margin: '0 auto', background: '#fff' }}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = noImagePlaceholder;
                        }}
                      />
                    ) : (
                      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#000' }}>
                        <ReactPlayer url={getAsset(item.src)} controls width="100%" height="100%" playing={i === currentSlide} config={{ file: { attributes: { playsInline: true } } }} />
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* prev/next */}
              {currentSlide > 0 && (
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); prev(); }}
                  aria-label="Previous"
                  style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.35)', color: '#fff', border: 'none', borderRadius: 20, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                >
                  ‹
                </button>
              )}

              {currentSlide < media.length - 1 && (
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); next(); }}
                  aria-label="Next"
                  style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.35)', color: '#fff', border: 'none', borderRadius: 20, width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                >
                  ›
                </button>
              )}

              {/* dots */}
              <div style={{ position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 8 }}>
                {media.map((_, i) => (
                  <button
                    key={i}
                    onClick={(e) => { e.stopPropagation(); setCurrentSlide(i); }}
                    style={{ width: 8, height: 8, borderRadius: 4, border: 'none', background: currentSlide === i ? '#fff' : 'rgba(255,255,255,0.45)', cursor: 'pointer' }}
                  />
                ))}
              </div>

              {/* counter */}
              <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.35)', color: '#fff', padding: '4px 8px', borderRadius: 12, fontSize: 12, zIndex: 2 }}>
                {currentSlide + 1}/{media.length}
              </div>
            </div>
          );
        })()
      }

      <div className="d-flex justify-content-between font-sm mt-1">
        <div>
          <div style={{ display: "flex", cursor: "pointer" }}>
            <p className="pe-2 mb-0">{post?.like?.count || 0} Like</p>
          </div>
        </div>
        <div>
          <div style={{ display: "flex", cursor: "pointer" }}>
            <p className="mb-0">{post?.dislike?.count || 0} Dislike</p>
          </div>
        </div>
        <div style={{ display: "flex", cursor: "pointer" }}>
          <p className="pe-3 mb-0">{post?.comment} Comments</p>
        </div>
        <div>
          <p className="mb-0">{post?.shareCount || 0} Shares</p>
        </div>
      </div>

      <div className="d-flex justify-content-between font-sm mt-2">
        <div
          className="d-flex align-items-center pt-1 pb-2 cursor_P"
          onClick={() => handleClick("like", post?._id)}
        >

          {post?.like?.isILike === true ? (
            <img
              className="w-img cursor_P"
              src={images.Activelike}
              alt="image"
            />
          ) : (
            <img className="w-img" src={images.Liked} alt="image" />
          )}
        </div>

        <div
          className="d-flex align-items-center pt-1 pb-2 cursor_P"
          onClick={() => handleClick("dislike", post?._id)}
        >
          {post?.dislike?.isIDislike && post?.dislike?.isIDislike === true ? (
            <img className="w-img" src={images.ActiveDislike} alt="image" />
          ) : (
            <img className="w-img" src={images.DisLiked} alt="image" />
          )}
        </div>

        <div
          className="d-flex pt-1 cursor_P"
          onClick={() => {
            handleCommentClick(post?._id);
            getTimelineComments(post?._id);
            setPostId(post?._id);
          }}
        >
          <ChatBubbleIcon sx={{ color: "#434343" }} />
          <p className="pe-2">Comment</p>
        </div>

        <div
          className="d-flex cursor_P"
          onClick={async (e) => {
            e.stopPropagation();
            try {
              await getShareTimeline();
            } catch (err) {
              console.error('Failed to load share options', err);
            }
            handleOpenShareModal && handleOpenShareModal(post?._id);
          }}
        >
          <RiShareForwardFill size={24} color="#434343" />
          <p className="mt-1">Share</p>
        </div>
      </div>

      {openCommentPostId === post?._id && (
        <Commentmodal
          id={id}
          postId={post?._id}
          comments={comments}
          comment={comment}
          composerIdentity={composerIdentity}
          resolveCommentIdentity={resolveCommentIdentity}
          refetchComments={getTimelineComments}
          handleclose={() => setOpenCommentPostId(null)}
          handleCommentChange={handleCommentChange}
          handleSubmit={handleSubmit}
        />
      )}
    </Row>
  );
};

export default PostItem;
